/**
 * Created by talm on 18/08/15.
 */
import _ from 'lodash'
import dataModel from '../../dataModel/dataModel'
import * as santaCoreUtils from '@wix/santa-core-utils'
import dsUtils from '../../utils/utils'
import language from '../../siteMetadata/language'

function setLinksCustomData(ps, compPointer, customStructureData) {
    const repeatedComponents = ps.pointers.components.getAllDisplayedOnlyComponents(compPointer)

    _.forEach(repeatedComponents, componentPointer => {
        const dataItem = dataModel.getDataItem(ps, componentPointer)
        const compData = _.get(dataItem, 'data.richText', dataItem)
        const repeatedItemId = santaCoreUtils.displayedOnlyStructureUtil.getRepeaterItemId(componentPointer.id)
        const linkListKey = repeatedItemId ? repeatedItemId : componentPointer.id

        if (_.has(compData, 'linkList') && compData.linkList.length > 0) {
            _.set(customStructureData, ['linkList', linkListKey], compData.linkList)
            _.set(customStructureData, 'originalCompId', linkListKey)
        }

        const translationLanguages = language.getTranslationLanguageCodes(ps)
        translationLanguages.forEach(languageCode => {
            const translatedDataItem = dataModel.multilingual.get(ps, languageCode, componentPointer)
            const translatedCompData = _.get(translatedDataItem, 'data.richText', translatedDataItem)
            if (translatedCompData?.linkList && translatedCompData.linkList.length > 0) {
                _.set(
                    customStructureData,
                    ['translations', 'linkList', languageCode, linkListKey],
                    translatedCompData.linkList
                )
                _.set(customStructureData, 'originalCompId', linkListKey)
            }
        })
    })

    return {success: true, description: 'Added text links to the custom component structure'}
}

const fixTextLinkAccordingToLinkList = (ps, text, originalLinkList, newLinkList) => {
    let textToFix = _.clone(text)
    _.forEach(originalLinkList, (linkData, index) => {
        const oldLinkId = linkData.id
        const newLinkId = newLinkList[index].id
        textToFix = textToFix.replace(`#${oldLinkId}`, `#${newLinkId}`)
    })
    return textToFix
}

const fixTextLinksAfterSetAddToRepeater = (ps, itemDataPointer, templateDataPointer) => {
    const repeatedData = ps.extensionAPI.dataModel.getItem(itemDataPointer.id, itemDataPointer.type)
    const templateData = ps.extensionAPI.dataModel.getItem(templateDataPointer.id, templateDataPointer.type)
    const fixedText = fixTextLinkAccordingToLinkList(
        ps,
        repeatedData.text,
        templateData.linkList,
        repeatedData.linkList
    )
    ps.extensionAPI.dataModel.addItem(
        {...repeatedData, text: fixedText},
        itemDataPointer.type,
        templateDataPointer.pageId,
        repeatedData.id
    )
}

const handleVerticalTextPropertyChange = (ps, componentPointer, updatedProperties) => {
    const currentProperties = dataModel.getPropertiesItem(ps, componentPointer)

    if (!currentProperties) {
        return
    }
    const currentVerticalText = currentProperties.verticalText
    const nextVerticalText = updatedProperties.verticalText
    const isNotEqualToCurrent = currentVerticalText !== nextVerticalText

    if (typeof nextVerticalText !== 'undefined' && isNotEqualToCurrent) {
        dataModel.updatePropertiesItem(ps, componentPointer, {packed: false})
    }
}

const cleanUnusedLinks = (ps, compPointer, dataItem) => {
    dataItem.linkList = _.filter(dataItem.linkList, ({id}) => _.includes(dataItem.text, dsUtils.stripHashIfExists(id)))
}

export default {
    cleanUnusedLinks,
    setLinksCustomData,
    handleVerticalTextPropertyChange,
    fixTextLinksAfterSetAddToRepeater
}
